/** Public product name shown in the UI. "bounce" (package.json) is the internal project name and must not be shown. */
export const APP_NAME = 'Padel House'
